var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrideLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2207,
    height: 767,
    viewBox: "0 0 2207 767",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1033.47 299.186H1084.91C1084.15 276.702 1079.86 257.363 1072.05 241.167C1064.24 224.971 1053.57 211.538 1040.05 200.867C1026.52 190.197 1010.8 182.385 992.895 177.431C974.987 172.477 955.555 170 934.599 170C915.929 170 897.736 172.382 880.018 177.145C862.301 181.909 846.489 189.149 832.581 198.867C818.674 208.584 807.53 220.969 799.147 236.022C790.765 251.075 786.574 268.89 786.574 289.469C786.574 308.142 790.288 323.67 797.718 336.056C805.148 348.441 815.055 358.539 827.438 366.351C839.821 374.164 853.823 380.451 869.445 385.215C885.067 389.978 900.974 394.17 917.167 397.79C933.361 401.411 949.268 404.936 964.89 408.365C980.512 411.795 994.514 416.273 1006.9 421.799C1019.28 427.324 1029.19 434.469 1036.62 443.234C1044.05 451.999 1047.76 463.431 1047.76 477.531C1047.76 492.394 1044.71 504.588 1038.62 514.115C1032.52 523.642 1024.52 531.168 1014.61 536.694C1004.71 542.22 993.562 546.126 981.178 548.412C968.795 550.699 956.508 551.842 944.315 551.842C929.074 551.842 914.215 549.937 899.736 546.126C885.257 542.315 872.588 536.408 861.729 528.406C850.87 520.403 842.107 510.209 835.439 497.824C828.771 485.439 825.437 470.672 825.437 453.523H774C774 478.294 778.477 499.729 787.431 517.831C796.385 535.932 808.577 550.794 824.009 562.417C839.44 574.04 857.347 582.709 877.732 588.426C898.117 594.142 919.739 597 942.6 597C961.27 597 980.035 594.809 998.896 590.426C1017.76 586.044 1034.81 578.994 1050.05 569.276C1065.29 559.559 1077.77 546.983 1087.48 531.55C1097.2 516.116 1102.06 497.538 1102.06 475.817C1102.06 455.619 1098.34 438.852 1090.91 425.514C1083.48 412.176 1073.58 401.125 1061.19 392.36C1048.81 383.595 1034.81 376.641 1019.18 371.496C1003.56 366.351 987.656 361.874 971.462 358.063C955.269 354.252 939.362 350.727 923.74 347.488C908.118 344.249 894.116 340.152 881.733 335.198C869.35 330.244 859.443 323.861 852.013 316.049C844.583 308.237 840.869 298.043 840.869 285.467C840.869 272.129 843.44 260.983 848.584 252.027C853.728 243.072 860.586 235.927 869.159 230.592C877.732 225.257 887.543 221.446 898.593 219.159C909.642 216.873 920.882 215.73 932.313 215.73C960.508 215.73 983.655 222.303 1001.75 235.45C1019.85 248.598 1030.42 269.843 1033.47 299.186ZM1218.08 292.327V203.726H1169.5V292.327H1119.2V335.198H1169.5V523.261C1169.5 536.98 1170.83 548.031 1173.5 556.415C1176.16 564.799 1180.26 571.277 1185.78 575.85C1191.31 580.423 1198.55 583.567 1207.5 585.282C1216.46 586.997 1227.22 587.854 1239.79 587.854H1276.94V544.983H1254.65C1247.03 544.983 1240.84 544.697 1236.08 544.125C1231.32 543.554 1227.6 542.315 1224.93 540.41C1222.27 538.504 1220.46 535.837 1219.5 532.407C1218.55 528.977 1218.08 524.404 1218.08 518.688V335.198H1276.94V292.327H1218.08ZM1319.81 292.327V587.854H1368.39V456.382C1368.39 437.327 1370.29 420.465 1374.1 405.793C1377.91 391.122 1384.01 378.641 1392.39 368.352C1400.77 358.063 1411.82 350.251 1425.54 344.916C1439.26 339.581 1455.83 336.913 1475.26 336.913V285.467C1448.97 284.705 1427.25 290.04 1410.11 301.473C1392.96 312.905 1378.48 330.625 1366.67 354.633H1365.53V292.327H1319.81ZM1554.13 239.166V179.718H1505.55V239.166H1554.13ZM1505.55 292.327V587.854H1554.13V292.327H1505.55ZM1655.87 442.663C1655.87 428.182 1657.39 414.082 1660.44 400.363C1663.49 386.644 1668.44 374.449 1675.3 363.779C1682.16 353.109 1691.3 344.535 1702.73 338.056C1714.16 331.578 1728.07 328.339 1744.45 328.339C1761.22 328.339 1775.5 331.483 1787.32 337.77C1799.13 344.058 1808.75 352.347 1816.18 362.636C1823.61 372.925 1829.04 384.834 1832.47 398.362C1835.9 411.891 1837.61 425.895 1837.61 440.376C1837.61 454.095 1835.99 467.623 1832.75 480.961C1829.51 494.299 1824.28 506.208 1817.04 516.687C1809.8 527.167 1800.46 535.646 1789.03 542.124C1777.6 548.603 1763.69 551.842 1747.31 551.842C1731.69 551.842 1718.07 548.793 1706.45 542.696C1694.82 536.599 1685.3 528.406 1677.87 518.116C1670.44 507.827 1664.91 496.109 1661.29 482.962C1657.68 469.815 1655.87 456.382 1655.87 442.663ZM1884.48 587.854V179.718H1835.9V331.768H1834.75C1829.42 323.004 1822.85 315.668 1815.04 309.761C1807.22 303.854 1798.94 299.091 1790.17 295.471C1781.41 291.85 1772.65 289.278 1763.88 287.754C1755.12 286.229 1746.93 285.467 1739.31 285.467C1716.83 285.467 1697.11 289.564 1680.16 297.757C1663.2 305.95 1649.1 317.001 1637.86 330.911C1626.62 344.82 1618.24 361.111 1612.72 379.784C1607.19 398.457 1604.43 418.273 1604.43 439.233C1604.43 460.192 1607.29 480.008 1613 498.681C1618.72 517.354 1627.19 533.741 1638.43 547.841C1649.67 561.941 1663.77 573.182 1680.73 581.566C1697.68 589.95 1717.59 594.142 1740.45 594.142C1761.03 594.142 1779.89 590.522 1797.03 583.281C1814.18 576.041 1826.75 564.227 1834.75 547.841H1835.9V587.854H1884.48ZM2155.38 411.795H1985.64C1986.4 400.363 1988.87 389.597 1993.07 379.499C1997.26 369.4 2002.97 360.54 2010.21 352.918C2017.45 345.297 2026.12 339.295 2036.22 334.912C2046.31 330.53 2057.65 328.339 2070.22 328.339C2082.41 328.339 2093.56 330.53 2103.66 334.912C2113.75 339.295 2122.52 345.201 2129.95 352.633C2137.38 360.064 2143.28 368.924 2147.66 379.213C2152.05 389.502 2154.62 400.363 2155.38 411.795ZM2202.24 494.108H2154.24C2150.05 513.544 2141.38 528.024 2128.23 537.552C2115.09 547.079 2098.23 551.842 2077.65 551.842C2061.65 551.842 2047.74 549.174 2035.93 543.839C2024.12 538.504 2014.4 531.359 2006.78 522.404C1999.16 513.448 1993.64 503.159 1990.21 491.536C1986.78 479.913 1985.26 467.623 1985.64 454.667H2206.82C2207.58 436.756 2205.96 417.893 2201.96 398.076C2197.96 378.26 2190.72 359.968 2180.24 343.201C2169.76 326.433 2155.86 312.619 2138.52 301.758C2121.18 290.898 2099.37 285.467 2073.08 285.467C2052.89 285.467 2034.31 289.278 2017.36 296.9C2000.4 304.521 1985.73 315.191 1973.35 328.91C1960.97 342.629 1951.34 358.825 1944.49 377.498C1937.63 396.171 1934.2 416.749 1934.2 439.233C1934.96 461.717 1938.29 482.485 1944.2 501.539C1950.11 520.594 1958.96 536.98 1970.78 550.699C1982.59 564.418 1997.16 575.088 2014.5 582.709C2031.83 590.331 2052.31 594.142 2075.94 594.142C2109.47 594.142 2137.28 585.758 2159.38 568.991C2181.48 552.223 2195.77 527.263 2202.24 494.108Z",
    fill: "#252535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 349.5L35 258.935V569.947L304.544 725.569L556.5 568L409.451 475.229",
    stroke: "#0AAC85",
    strokeWidth: 70
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185 349.5L35 258.935V569.947L304.544 725.569L556.5 568L409.451 475.229",
    stroke: "url(#paint0_linear)",
    strokeWidth: 70
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185 349.5L35 258.935V569.947L304.544 725.569L556.5 568L409.451 475.229",
    stroke: "url(#paint1_linear)",
    strokeWidth: 70
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 412.699L586.889 508.351V196.621L317.345 41L65.5 197.5L215.056 294.143",
    stroke: "#0AD0B9",
    strokeWidth: 70
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 412.699L586.889 508.351V196.621L317.345 41L65.5 197.5L215.056 294.143",
    stroke: "url(#paint2_linear)",
    strokeWidth: 70
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 412.699L586.889 508.351V196.621L317.345 41L65.5 197.5L215.056 294.143",
    stroke: "url(#paint3_linear)",
    strokeWidth: 70
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M306.499 539.999L439.227 461.382L439.683 303.383L307.411 224.001L174.684 302.618L174.228 460.617L306.499 539.999Z",
    stroke: "#7A27F3",
    strokeOpacity: 0.92,
    strokeWidth: 70
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M306.499 539.999L439.227 461.382L439.683 303.383L307.411 224.001L174.684 302.618L174.228 460.617L306.499 539.999Z",
    stroke: "url(#paint4_linear)",
    strokeWidth: 70
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 670,
    y1: 872,
    x2: 304,
    y2: 272.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#0AAC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#11C9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 344.5,
    y1: 332,
    x2: 109.5,
    y2: 738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A27F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 377.5,
    y1: 732,
    x2: 922.5,
    y2: 475.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#2585D7",
    stopOpacity: 0.543036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#0AD0B9",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -91.0001,
    y1: 571.5,
    x2: 105.5,
    y2: -60.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285321,
    stopColor: "#7A27F3",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 489.455,
    y1: 196.5,
    x2: 163.955,
    y2: 471.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103969,
    stopColor: "#FC5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrideLogo);
export default __webpack_public_path__ + "static/media/stride-logo.2c005be3d07610026e385714dbd0445b.svg";
export { ForwardRef as ReactComponent };